import TYPES from '@/types';
import { v4 } from 'uuid';

// Application
import CustomerOverviewService from '@/modules/home-dashboard/customer-overview/application/services/customer-overview-service';
import InvestmentSuggestionCommand
  from '@/modules/investment-suggestion/application/commands/investment-suggestion-command';

// Domain
import {
  InvestmentSuggestionDto,
} from '@/modules/investment-suggestion/domain/dtos/investment-suggestion-dto';
import CustomerOverviewState from '@/modules/home-dashboard/customer-overview/domain/state/customer-overview-state';
import Inject from '@/modules/shared/domain/di/inject';
import { MessageNotifier } from '@/modules/shared/domain/notifiers/message_notifier';
import { Values } from '@/modules/shared/domain/i18n/types';
import Translator from '@/modules/shared/domain/i18n/translator';

export default class FlagshipProfilingCardViewModel {
  @Inject(TYPES.CUSTOMER_OVERVIEW_SERVICE)
  private readonly customer_overview_service!: CustomerOverviewService;

  @Inject(TYPES.CREATE_INVESTMENT_SUGGESTION_COMMAND)
  private readonly create_investment_suggestion_command!: InvestmentSuggestionCommand;

  @Inject(TYPES.I18N)
  private readonly translator!: Translator;

  @Inject(TYPES.NOTIFIER)
  readonly message_notifier!: MessageNotifier;

  readonly i18n_namespace = 'components.my-investment-dashboard.flagship-profiling-card.flagship_profiling_card';

  is_loading = false;

  investor_profile_complete = false;

  goals_completed = false;

  show_flagship_profiling_modal = false;

  has_any_product_contracted = false;

  private investment_suggestion_dto: InvestmentSuggestionDto = {
    id: v4(),
    investment_suggestion_analytic_id: '',
    action: 'flagship',
  }

  customer_overview: CustomerOverviewState = this.customer_overview_service.get_customer_overview();

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  get background_image() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
    const bgImage = require('@/assets/images/goals-dashboard/goals_dashboard_white.svg');
    return {
      backgroundImage: `url(${bgImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundPositionX: 'right',
      backgroundPositionY: 'bottom',
      backgroundSize: 'contain',
    };
  }

  showFlagshipProfilingModal = async () => {
    await this.obtainInvestmentSuggestion();
    this.show_flagship_profiling_modal = true;
  }

  obtainInvestorProfile = async () => {
    this.investor_profile_complete = this.customer_overview.item.investor_profile_overview
      .is_completed;
    this.goals_completed = this.customer_overview.item.goals_overview.goals_completed;
  }

  loadCustomerContractedProductsInformation = () => {
    this.has_any_product_contracted = this.customer_overview.item.has_any_product_contracted;
  }

  obtainInvestmentSuggestion = async () => {
    const { investment_suggestion_analytic_id, must_be_shown } = this
      .customer_overview.item.investment_suggestion_overview;
    if (must_be_shown) {
      this.investment_suggestion_dto
        .investment_suggestion_analytic_id = investment_suggestion_analytic_id;
      await this.createInvestmentSuggestionAction();
    }
  }

  createInvestmentSuggestionAction = async () => {
    try {
      await this.create_investment_suggestion_command.execute(this.investment_suggestion_dto);
    } catch {
      this.message_notifier.showErrorNotification(this.translate('errors.create_investment_suggestion_action'));
    }
  }

  createGoals = () => {
    window.location.href = '/goals-dashboard?create_goals=true';
  }

  endProcessProfiling = (recommended_investment_product_id: string) => {
    this.show_flagship_profiling_modal = false;
    window.location.href = `/goals-dashboard?recommended_investment_product=${recommended_investment_product_id}`;
  }

  async initialize() {
    this.is_loading = true;
    await this.obtainInvestorProfile();
    await this.loadCustomerContractedProductsInformation();
    this.is_loading = false;
  }
}
